import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

const KakaoLogo = () => (
  <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_1005_297943)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.4868 2.68127C6.35243 2.68127 3 5.45252 3 8.88888C3 11.0172 4.29771 12.8795 6.26924 14.0102L5.43737 17.2603C5.42124 17.3243 5.42393 17.392 5.44508 17.4544C5.46622 17.5167 5.50479 17.5706 5.5556 17.6088C5.6064 17.647 5.66698 17.6676 5.72915 17.668C5.79132 17.6683 5.85208 17.6482 5.90323 17.6106L9.54681 15.0344C9.8546 15.0654 10.1665 15.0832 10.4827 15.0832C14.617 15.0832 17.9695 12.3119 17.9695 8.87558C17.9695 5.43922 14.617 2.66797 10.4827 2.66797'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_775_308878'>
        <rect width='20' height='20' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
);

interface KakaoPurchaseButtonProps {
  onClick: () => void;
}

export const KakaoPurchaseButton = ({ onClick }: KakaoPurchaseButtonProps) => (
  <PurchaseButton type='button' onClick={onClick}>
    <KakaoLogo />
    <span className={Typography.BODY_15_SEMIBOLD}>카카오로 간편구매</span>
  </PurchaseButton>
);

const PurchaseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  padding: 16px 24px;
  border-radius: 24px;
  background: ${vars.v3Color.black} !important;
  color: ${vars.v3Color.white};
  cursor: pointer;

  span {
    margin-left: 4px;
  }
`;
